 document.addEventListener('DOMContentLoaded', function() {
    
    const menuToggle = document.getElementById('nav-bar-btn');
    const menu = document.getElementById('navigation-menu');

    const visible = "visible opacity-100".split(" ")
    const invisible = "invisible opacity-0".split(" ")
    
    menuToggle.addEventListener('click', function() {
      if(menu.classList.contains(invisible[0])){
        invisible.map( item => menu.classList.remove(item))
        visible.map( item =>  menu.classList.add(item) )
       
      }else{
        visible.map( item => menu.classList.remove(item))
        invisible.map( item =>  menu.classList.add(item) )
      }
    });
  });